import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icons/home.png';
import _imports_1 from '../../../assets/icons/hint.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-76241542"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "aboutUs" };
var _hoisted_2 = { class: "back" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/ _createTextVNode("您的位置 : ")
], -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", null, "首页", -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "hintInfo" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_1 }),
    /*#__PURE__*/ _createElementVNode("p", null, "暂无招聘信息")
], -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_Nav = _resolveComponent("Nav");
    var _component_HomeJumbotron = _resolveComponent("HomeJumbotron");
    var _component_el_col = _resolveComponent("el-col");
    var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
    var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
    var _component_el_row = _resolveComponent("el-row");
    var _component_BasisGroup = _resolveComponent("BasisGroup");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Nav, { navActiveIndex: _ctx.navActiveIndex }, null, 8, ["navActiveIndex"]),
        _createVNode(_component_HomeJumbotron),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_row, null, {
                default: _withCtx(function () { return [
                    _createVNode(_component_el_col, {
                        md: 4,
                        xs: 1
                    }),
                    _createVNode(_component_el_col, {
                        md: 16,
                        xs: 22
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_breadcrumb_item, null, {
                                            default: _withCtx(function () { return [
                                                _hoisted_3
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_4
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, null, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode("人才招聘")
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _hoisted_5
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_component_el_col, { span: 4 })
                ]; }),
                _: 1
            })
        ]),
        _createVNode(_component_BasisGroup)
    ], 64));
}
